/**
 * Returns a random number between min and max (inclusive). This function is
 * not cryptographically secure. It is intended for things like randomizing
 * survey respondent order, the order of questions, or randomly spacing out
 * batch task executions to avoid system strain.
 */
export function getRandomNumberBetween(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
